/**
 * The capabilities the Function App answers for in `GET api/me`, one flag each, spelled as the
 * server spells them (`Security/Access/Capability.cs` in the Function App). A user's flags are
 * the union of the grants of every role they hold. `getMe` rejects a reply that lacks a flag for
 * any key here, so a key the server stops sending fails the read rather than reading as "may
 * not". A key the server sends and this list does not name is ignored: nothing can ask for it.
 *
 * `CapabilityKey` is a union of string literals, so `useCan("manageTool")` is a compile error
 * rather than a check that is always false.
 */
export const CAPABILITY_KEYS = [
  "viewSettings",
  "manageSettings",
  "viewTools",
  "manageTools",
  "viewOperations",
  "manageOperations",
  "viewUsers",
  "manageUsers",
  "viewCapacity",
  "manageCapacity",
  "schedule",
  "import",
  "buildReports",
  "shareReports",
  "viewJobs",
  "workJobs",
  "writeBackJobs",
  "reworkJobs",
  "deleteJobs",
  "viewDocuments",
  "manageDocuments",
  "print",
  "runReports",
  "useSupport",
  "reworkQuarantinedJobs",
  "switchOrganization",
] as const;

export type CapabilityKey = typeof CAPABILITY_KEYS[number];

/** One flag per capability, as `GET api/me` answers it. */
export type CapabilityMap = Readonly<Record<CapabilityKey, boolean>>;
